import { UniversalExpanderDataColumn } from "../../UniversalExpanderDataColumn";
import { BankStatementIncomeSource } from "../../../types";
import { UniversalSubTable } from "../../UniversalSubTable";
import { ColumnDef } from "@tanstack/react-table";
import { DocumentCard } from "../../DocumentCard";
import {
  getBankStatementDetailsMappings,
  getBankStatementIncomeSummaryMappings
} from "../utils";
import { transactionColumns } from "../columns/TransactionsColumns";

export const BankStatementDetails = ({
  bankStatementData
}: {
  bankStatementData: BankStatementIncomeSource;
}) => {
  const bankAccountDetailsData =
    getBankStatementDetailsMappings(bankStatementData);
  return bankStatementData.uploaded_docs.map((doc, idx) => {
    const docIncomeSummary = bankStatementData.periods?.find(
      (period) => period.uploaded_doc_pk === doc.pk
    );
    const incomeSummaryData =
      getBankStatementIncomeSummaryMappings(docIncomeSummary);
    return (
      <div key={doc.uuid} className="flex flex-col gap-3">
        <div className="mt-3 border-b border-alpha-100">
          <p className="w-fit border-b-2 border-content-1000 text-content-1000 font-medium text-sm pb-2">
            Bank statement {idx + 1}
          </p>
        </div>

        <div className="mb-4">
          {doc.asset?.asset ? (
            <DocumentCard
              score={
                doc.doc_analysis.form_analysis[0]?.form_authenticity?.score || 0
              }
              asset={doc.asset.asset}
              reason_codes={
                doc.doc_analysis.form_analysis[0]?.form_authenticity
                  ?.reason_codes
              }
            />
          ) : null}
        </div>
        <UniversalExpanderDataColumn
          title="Bank account details"
          data={bankAccountDetailsData}
        />
        <UniversalExpanderDataColumn
          title="Income summary"
          data={incomeSummaryData}
        />
        <UniversalSubTable
          tableData={doc.transactions}
          tableColumns={transactionColumns as ColumnDef<unknown, any>[]}
        />
      </div>
    );
  });
};
